import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricGraphScreen from './metric-graph-screen-model'
import {
  delete_metricGraphScreen,
  load_metricGraphScreens,
  store_metricGraphScreen,
} from './metricGraphScreen-service'

export const LoadMetricGraphScreensAsync = createAsyncThunk<any, any>(
  'composer/load/metricGraphScreen',
  async (params: { uid: string }) => {
    return await load_metricGraphScreens(params)
  },
)

export const CreateMetricGraphScreenAsync = createAsyncThunk<any, any>(
  'composer/create/metricGraphScreen',
  async (params: MetricGraphScreen) => {
    return await store_metricGraphScreen(params)
  },
)

export const DeleteMetricGraphScreenAsync = createAsyncThunk<any, any>(
  'composer/delete/metricGraphScreen',
  async (params) => {
    return await delete_metricGraphScreen(params)
  },
)
